<div class="page-title-area">
    <div class="container">
      <div class="page-title-content">
        <h2>End Of Life Management</h2>
        <ul>
          <li><a routerLink="/services">Services</a></li>
          <li>End Of Life Management</li>
        </ul>
      </div>
    </div>
  </div>